import shopifyGenericDefaults from '../shopify-generic/config.js';

window.Convermax.filteredByVehicle = () => window.document.body.classList.contains('cm_filtered_by_vehicle');

const isBrakesCollection = [
  'brakes',
  'big-brake-kits',
  'brake-fluid',
  'brake-lines',
  'brake-pads',
  'brake-rotors',
  'rotor-pad-kits',
].some((handle) => window.location.pathname === `/collections/${handle}`);

window.Convermax.addToCart = (e) => {
  const form = e.currentTarget.closest('form');
  const themeEventsAvailable = !!window.document
    .querySelector('script[type="importmap"]')
    ?.textContent.includes('@shopify/events');

  if (!form?.querySelector('input[name="id"]')?.value || !themeEventsAvailable) {
    return;
  }

  e.preventDefault();

  themeAddToCart(form);
};

async function themeAddToCart(form) {
  const { CartLinesUpdateEvent } = await import(/* webpackIgnore: true */ String('@shopify/events'));

  const formData = new FormData(form);
  const sectionIds = [...window.document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  if (sectionIds.length) {
    formData.append('sections', sectionIds.join(','));
  }

  const quantity = Number(formData.get('quantity')) || 1;
  const deferred = CartLinesUpdateEvent.createPromise();

  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: formData.get('id'), quantity }],
      promise: deferred.promise,
    }),
  );

  try {
    const response = await fetch(`${window.Convermax.Shopify?.cartAddUrl || '/cart/add'}.js`, {
      method: 'POST',
      body: formData,
    }).then((r) => r.json());
    const ajaxCart = await fetch('/cart.js').then((r) => r.json());

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
      detail: {
        items: ajaxCart.items,
        source: 'product-form-component',
        sourceId: form.id,
        itemCount: quantity,
        sections: response.sections,
        didError: !!response.status,
      },
    });
  } catch (err) {
    deferred.reject(err);
  }
}

function responseHandler(response) {
  const { Facets } = response;
  const isFilteredByVehicle = !Facets.find(
    (f) => f.FieldName === 'FilterByVehicle' && f.Selection.length > 0,
  );

  window.document.body.classList.toggle('cm_filtered_by_vehicle', isFilteredByVehicle);

  return response;
}

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  responseHandler,
  pagination: {
    centralRange: 1,
    edgeRange: 1,
    disableDelimiters: true,
  },
  fitmentSearch: {
    ...shopifyGenericDefaults.fitmentSearch,
    categorySelectionPages: [
      ...shopifyGenericDefaults.fitmentSearch.categorySelectionPages.filter(
        (page) => page.field !== 'vendor',
      ),
      {
        pathname: window.document.querySelector('#cm-brands-list') ? window.location.pathname : null,
        field: 'vendor',
      },
    ],
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'SearchBox',
          'SearchHeader',
          'FacetCategoryTiles',
          'FacetBrandTiles',
          'HeaderVehicleWidget',
          'Garage',
          'VehicleWidgetDialog',
          'SearchVehicleWidget',
          'VehicleSpecs',
          'FacetDialog',
        ].includes(w.name),
    ),
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'SearchBox'),
      location: { selector: '#cm-search-box', class: 'cm_search-box-root__container' },
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'SearchHeader'),
      facetToggleConfig: {
        isInverted: true,
        toggledFacet: { field: 'FilterByVehicle', term: 'False' },
      },
    },
    {
      name: 'HeaderVehicleWidget',
      type: 'VehicleWidget',
      location: '#cm-ymm',
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 650,
      initCollapsed: !!window.Convermax.config?.ymmInitCollapsed,
      fields:
        !!window.Convermax.config?.extraFieldsAsFilters && shopifyGenericDefaults.fitmentSearch.baseFields,
      isVehicleSelectionIsolated: !!window.Convermax.config?.isVehicleSelectionIsolated,
    },
    {
      ...shopifyGenericDefaults.Widgets.find((widget) => widget.name === 'FacetCategoryTiles'),
      isVehicleWidgetDisabled: false,
    },
    {
      ...shopifyGenericDefaults.Widgets.find((widget) => widget.name === 'FacetBrandTiles'),
      location: '#cm-brands-list',
      isVehicleWidgetDisabled: false,
    },
    {
      ...shopifyGenericDefaults.Widgets.find((widget) => widget.name === 'Garage'),
      doNotRedirectOnVehicleSelect: window.location.pathname !== '/',
    },
    {
      ...shopifyGenericDefaults.Widgets.find((widget) => widget.name === 'VehicleWidgetDialog'),
      doNotRedirectOnVehicleSelect: window.location.pathname !== '/',
    },
    {
      ...shopifyGenericDefaults.Widgets.find((widget) => widget.name === 'SearchVehicleWidget'),
      doNotRedirectOnVehicleSelect: window.location.pathname !== '/',
    },
    {
      ...shopifyGenericDefaults.Widgets.find((widget) => widget.name === 'VehicleSpecs'),
      visibleIf: () => !!window.Convermax.config?.extraFieldsAsFilters && !isBrakesCollection,
    },
    {
      ...shopifyGenericDefaults.Widgets.find((widget) => widget.name === 'FacetDialog'),
      template: isBrakesCollection ? 'FacetDialog' : 'FacetDialogVehicleSpecs',
    },
  ],
};
